<template>
    <div v-loading.body="showLoading">
        <iframe :src="rechargeUrl" frameborder="0" class="iframe" v-if="rechargeUrl" id="iframe"></iframe>
        <iframe :src="directRechargeUrl" frameborder="0" class="iframe" v-if="!rechargeUrl" id="iframe"></iframe>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                directRechargeUrl: '',
                showLoading: false
            }
        },
        props: ['channelKey', 'user', 'browserInfo', 'rechargeUrl', 'methodInfo'],
        methods: {
            directRecharge() {
                this.showLoading = true;
                this.$http.get('recharge/' + this.channelKey + '/pay?uid=' + this.user.uid + '&token=' + this.user.accessToken + '&browser_version=' + this.browserInfo.version + '&browser_name=' + this.browserInfo.name).then(
                    function (response) {
                        this.showLoading = false;
                        let apiResult = response.data;
                        if (apiResult == -1) {
                            this.$alert(this.$t('createOrderFailTryAgain'), this.$t('createOrderFail'), {
                                confirmButtonText: this.$t('confirm'),
                            });
                        } else {
                            this.directRechargeUrl = apiResult;
                        }
                    },
                    function (response) {
                        this.showLoading = false;
                        this.$alert(this.$t('systemErrorTryLater'), this.$t('systemError'), {
                            confirmButtonText: this.$t('confirm'),
                        });
                    }
                );
            }
        },
        created() {
            if (!this.rechargeUrl) {
                this.directRecharge();
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .iframe {
        width: 100%;
        min-height: 400px;
        max-height: 600px;
    }
</style>


// WEBPACK FOOTER //
// RechargeByDirect.vue?f9090174